export default [
  {
    path: '/pvh/roles/list',
    name: 'PvhRoleList',
    component: () => import('@/views/Pvh/PvhRoleList.vue')
  },
  {
    path: '/pvh/roles/update/:id',
    name: 'PvhRoleUpdate',
    component: () => import('@/views/Pvh/PvhRoleUpdate.vue'),
    redirect: {
      name: 'PvhRoleList_roleTab'
    },
    children: [
      {
        path: 'role',
        name: 'PvhRoleList_roleTab',
        component: () => import('@/components/pvh/PvhRoleMainUpdateInfo')
      },
      {
        path: 'users',
        name: 'PvhRoleList_usersTab',
        component: () => import('@/components/pvh/PvhRoleUsersUpdateInfo')
      }
    ]
  }
]
